var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":"","outline":"","small":""},on:{"click":_vm.open}},[_vm._v(" Email Reviewers ")])
}
var staticRenderFns = []

export { render, staticRenderFns }